import {TFunction} from 'i18next';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonBadlXlsxDataProcessor} from '../export-care-plan-common-badl-xlsx-data';

export class PositionMobilityXlsxDataProcessor extends CommonBadlXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.additionalEntries = [
      this.additionalEntry.positioning,
      this.additionalEntry.mobility,
      this.additionalEntry.requiredAssistance,
    ];
  }
}
